import apiConfig from "@/configs/api-config";
import apiUtil from "@/utils/api-util";

// 列表
var list = (successCallback, failCallback) => {
    apiUtil.config(apiConfig.price.list).request().then(result => {
        if(result.error_code == apiConfig.errorCode.success) {
            successCallback(result.data);
        } else {
            failCallback(result.error_code, result.errorMsg);
        }
    });
}
export default {
    list
}


// WEBPACK FOOTER //
// ./src/models/price-model.js